import { Component, OnInit } from '@angular/core';

import { Input, Output, EventEmitter } from '@angular/core';

import { FormGroup, FormControl } from '@angular/forms';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Router } from '@angular/router';

import * as sha1 from 'js-sha1';


const httpOptions = {
  headers: new HttpHeaders(
    {
      'Content-Type': 'application/json',
    }
  )
};

interface UserInput {
  iduser: number;
  prenom: string;
};



@Component({
  selector: 'app-authentification',
  templateUrl: './authentification.component.html',
  styleUrls: ['./authentification.component.css']
})
export class AuthentificationComponent implements OnInit {

  login = "";
  pwd = "";

  mustChangepwd = 0;
  nwpwd = "";
  nwpwdconfirmed = "";

  erreurLogin = 0;
  erreurCoher = 0;

  fdg: any;
  canOnlyPrepay = false;

  ROUTES = [];


  constructor(private http: HttpClient, private router: Router) { }

  ngOnInit(): void {
  }


  farLogin() {
    let logdata = { login: this.login, pwd: sha1(this.pwd) };

    // Code to deCommente for dev purposes under airplane mode (no network)

    //this.router.navigate(['/homecpnt']) ;
    this.remotelogger('https://dkm.sentelecom.com/gestion/yeurrlouBO.php', logdata).subscribe(
      retourPost => {

        console.log("RetourPost: ", retourPost);

        if (retourPost["statutreq"] != undefined && retourPost["statutreq"] == 1) {
          this.erreurLogin = 0;

          sessionStorage.setItem("profil", retourPost["data"].profil.toString());
          sessionStorage.setItem("compliances", retourPost["data"].compliances);
          sessionStorage.setItem("meunmeun", retourPost["data"].habilit);
          sessionStorage.setItem("samacaabiyoonwii", retourPost["data"].token.toString());
          sessionStorage.setItem("agence", retourPost["data"].agence.toString());
          sessionStorage.setItem("codeemetteur", retourPost["data"].code.toString());
          sessionStorage.setItem("tourouwaadji", retourPost["data"].prenom + " " + retourPost["data"].nom);


          console.log("Nom Vendeur on AuthComponent :", retourPost["data"].prenom + " " + retourPost["data"].nom);

          if (retourPost["data"].firstuse != 1) {
            let usrInfos = retourPost;
            this.diottCiYoonYimaSagnaDieul(retourPost["data"].profil.toString(), retourPost["data"].compliances);
            this.router.navigate([this.ROUTES[0].path]);
          } else {
            this.mustChangepwd = 1;
            this.fdg = retourPost["data"].profil;
          }
        }
        else {
          console.log("FAILED: ", retourPost);
          this.erreurLogin = 1;
        }
      });
  }

  isOnlyPrepaidAuthorized(compliances) {
    let allOfThem = JSON.parse(compliances);
    this.canOnlyPrepay = false;
    for (var i = 0; i < allOfThem.length; i++) {
      if (allOfThem[i].name == "solde_impaye")
        this.canOnlyPrepay = Number(allOfThem[i].valeur) <= 0;
    }
  }


  diottCiYoonYimaSagnaDieul(profil, compliances) {
    console.log("Profil: ", profil);

    if (profil == "ADMINISTRATEUR") {
      sessionStorage.setItem("portee", "0");
      sessionStorage.setItem("action", "1");
      this.ROUTES = [
        { path: '/homecpnt/dashboard', title: 'Dashboard', icon: 'dashboard', class: '' },
        { path: '/homecpnt/recouvrement', title: 'Recouvrement', icon: 'warning', class: '' },
        { path: '/homecpnt/ventes', title: 'Ventes', icon: 'shopping_cart', class: '' },
        { path: '/homecpnt/depenses', title: 'Dépenses', icon: 'receipt_long', class: '' },
        { path: '/homecpnt/stock', title: 'Stock', icon: 'inventory_2', class: '' },
        { path: '/homecpnt/inventaire', title: 'Inventaire', icon: 'assignment_turned_in', class: '' },
        { path: '/homecpnt/crm', title: 'CRM | Client', icon: 'supervisor_account', class: '' },
        { path: '/homecpnt/partners', title: 'Réseau', icon: 'hub', class: '' },
        { path: '/homecpnt/about', title: 'A Propos', icon: 'info', class: '' },
        /*{ path: '/homecpnt/stockmovement', title: 'Mouvement De Stock',  icon:'content_paste', class: '' },*/
        /*{ path: '/homecpnt/histotransact', title: 'Reporting',  icon:'library_books', class: '' },*/
      ];

    } else if (profil == "Contrôleur de Gestion") {
      sessionStorage.setItem("portee", "0");
      sessionStorage.setItem("action", "0");
      this.ROUTES = [
        { path: '/homecpnt/dashboard', title: 'Dashboard', icon: 'dashboard', class: '' },
        { path: '/homecpnt/recouvrement', title: 'Recouvrement', icon: 'warning', class: '' },
        { path: '/homecpnt/depenses', title: 'Dépenses', icon: 'receipt_long', class: '' },
        { path: '/homecpnt/stock', title: 'Stock', icon: 'inventory_2', class: '' },
        { path: '/homecpnt/crm', title: 'CRM | Client', icon: 'supervisor_account', class: '' },
        { path: '/homecpnt/caisse', title: 'Gestion Caisse', icon: 'account_balance_wallet', class: '' },
        { path: '/homecpnt/banque', title: 'Banque & Versement', icon: 'account_balance', class: '' },
        { path: '/homecpnt/credit-fournisseur', title: 'Crédit Fournisseur', icon: 'local_shipping', class: '' },
        { path: '/homecpnt/about', title: 'A Propos', icon: 'info', class: '' },
      ];
    } else if (profil == "caisse" || profil == "Caisse" || profil == "CAISSE" || profil == "Caissier" || profil == "caissier") {
      sessionStorage.setItem("portee", "1");
      sessionStorage.setItem("action", "0");
      this.ROUTES = [
        { path: '/homecpnt/caisse', title: 'Gestion Caisse', icon: 'account_balance_wallet', class: '' },
        { path: '/homecpnt/recouvrement', title: 'Recouvrement', icon: 'warning', class: '' },
      ];
    }
    else {
      if (profil == "Gestionnaire Boutique") {
        sessionStorage.setItem("portee", "1");
        sessionStorage.setItem("action", "0");
        this.ROUTES = [
          { path: '/homecpnt/dashboard', title: 'Dashboard', icon: 'dashboard', class: '' },
          { path: '/homecpnt/recouvrement', title: 'Recouvrement', icon: 'warning', class: '' },
          { path: '/homecpnt/ventes', title: 'Ventes', icon: 'shopping_cart', class: '' },
          { path: '/homecpnt/depenses', title: 'Dépenses', icon: 'receipt_long', class: '' },
          { path: '/homecpnt/stock', title: 'Stock', icon: 'inventory_2', class: '' },
          { path: '/homecpnt/inventaire', title: 'Inventaire', icon: 'assignment_turned_in', class: '' },
          { path: '/homecpnt/crm', title: 'CRM | Client', icon: 'supervisor_account', class: '' },
          { path: '/homecpnt/about', title: 'A Propos', icon: 'info', class: '' },
        ];
      } else {
        if (profil == "Membre du Board") {
          sessionStorage.setItem("portee", "0");
          sessionStorage.setItem("action", "0");
          this.ROUTES = [
            { path: '/homecpnt/dashboard', title: 'Dashboard', icon: 'dashboard', class: '' },
            { path: '/homecpnt/recouvrement', title: 'Recouvrement', icon: 'warning', class: '' },
            { path: '/homecpnt/ventes', title: 'Ventes', icon: 'shopping_cart', class: '' },
            { path: '/homecpnt/depenses', title: 'Dépenses', icon: 'receipt_long', class: '' },
            { path: '/homecpnt/stock', title: 'Stock', icon: 'inventory_2', class: '' },
            { path: '/homecpnt/inventaire', title: 'Inventaire', icon: 'assignment_turned_in', class: '' },
            { path: '/homecpnt/crm', title: 'CRM | Client', icon: 'supervisor_account', class: '' },
            { path: '/homecpnt/partners', title: 'Réseau', icon: 'hub', class: '' },
            { path: '/homecpnt/about', title: 'A Propos', icon: 'info', class: '' },
            /*{ path: '/homecpnt/stockmovement', title: 'Mouvement De Stock',  icon:'content_paste', class: '' },*/
          ];
        } else {
          if (profil == "Vendeur") {
            sessionStorage.setItem("portee", "1");
            sessionStorage.setItem("action", "0");
            this.ROUTES = [
              { path: '/homecpnt/recouvrement', title: 'Recouvrement', icon: 'warning', class: '' },
              { path: '/homecpnt/ventes', title: 'Ventes', icon: 'shopping_cart', class: '' },
              { path: '/homecpnt/stock', title: 'Stock', icon: 'inventory_2', class: '' },
              { path: '/homecpnt/depenses', title: 'Dépenses', icon: 'receipt_long', class: '' },
              { path: '/homecpnt/crm', title: 'CRM | Client', icon: 'supervisor_account', class: '' },
              /*{ path: '/homecpnt/stockmovement', title: 'Mouvement De Stock',  icon:'content_paste', class: '' },*/
            ];
          } else {
            sessionStorage.setItem("portee", "3");
            sessionStorage.setItem("action", "0");
            this.ROUTES = [
              { path: '/homecpnt/ventes', title: 'Ventes', icon: 'shopping_cart', class: '' },
              { path: '/homecpnt/crm', title: 'CRM | Client', icon: 'supervisor_account', class: '' },
              /*{ path: '/homecpnt/histotransact', title: 'Reporting',  icon:'library_books', class: '' },*/
            ];
          }
        }
      }
    }


    sessionStorage.setItem("yoonyifiam", JSON.stringify(this.ROUTES));
  }



  updatePwd() {

    if (this.nwpwdconfirmed != this.nwpwd)
      this.erreurCoher = 1;
    else {
      let updtedata = { login: this.login, nwpwd: sha1(this.nwpwd) };
      this.erreurCoher = 0;

      this.remoteupdtepwd('https://dkm.sentelecom.com/gestion/sopandikouleiCaabi.php', updtedata).subscribe(
        retourPost => {
          if (retourPost["statutreq"] != undefined && retourPost["statutreq"] == 1) {
            this.login = "";
            this.pwd = "";
            this.mustChangepwd = 0;
          }
          else
            console.log("FAILED Update");
        });

    }
  }

  remotelogger(url: string, user: any) {
    return this.http.post(url, user, httpOptions);
  }

  remoteupdtepwd(url: string, user: any) {
    return this.http.post(url, user, httpOptions);
  }


}
